<template>
	<article>
		<dl>
			<dt>ID</dt>
			<dd>{{ token.id }}</dd>
			<dt>Name</dt>
			<dd>
				<span v-if="isEditingName">
					<input v-model="editingName" @keydown.enter.prevent="submitNameChange" required />
					<button @click.prevent="cancelEditName">x</button>
				</span>
				<button
					v-else
					class="editable-field"
					@click.prevent="requestEditName"
				>
					{{ token.name }}
				</button>
			</dd>
			<dt>Created time</dt>
			<dd><time>{{ createdLocalTime }}</time></dd>
			<dt>Last seen time</dt>
			<dd v-if="token.last_seen"><time>{{ lastSeenLocalTime }}</time></dd>
			<dd v-else><em>never</em></dd>
			<dt>User Agent</dt>
			<dd>{{ token.user_agent }}</dd>
		</dl>

		<div class="actions">
			<button @click.prevent="requestDelete" title="Delete">
				{{ deleteButtonLabel }}
			</button>
		</div>
	</article>
</template>

<script>
export default {
	name: 'ApiTokenListItem',
	props: {
		token: {
			type: Object,
			required: true,
		},
	},
	emits: [
		'requestNameChange',
		'requestDelete',
	],
	data() {
		return {
			isEditingName: false,
			editingName: null,
			deleteNeedsConfirmation: true,
		};
	},
	computed: {
		createdLocalTime() {
			const date = new Date(`${this.token.created_time}Z`);

			return date.toLocaleString();
		},
		lastSeenLocalTime() {
			const date = new Date(`${this.token.last_seen}Z`);

			return date.toLocaleString();
		},
		deleteButtonLabel() {
			if (this.deleteNeedsConfirmation) {
				return 'x';
			}

			return 'Confirm?';
		},
	},
	methods: {
		requestEditName() {
			this.editingName = this.token.name;
			this.isEditingName = true;
		},
		cancelEditName() {
			this.isEditingName = false;
		},
		submitNameChange() {
			if (this.editingName.trim() === '') {
				return;
			}

			this.$emit('requestNameChange', this.editingName);
			this.cancelEditName();
		},
		requestDelete() {
			if (this.deleteNeedsConfirmation) {
				this.deleteNeedsConfirmation = false;

				setTimeout(() => {
					this.deleteNeedsConfirmation = true;
				}, 5000);

			} else {
				this.$emit('requestDelete');
			}
		},
	},
};
</script>

<style scoped>
article {
	position: relative;
	margin: 0.5em 0;
	padding: 0.3em;
	background: #fff;
	border-radius: 4px;
}

article > dl {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin: 0 0.3em;
}

dt {
	font-weight: 700;
}

article time {
	display: block;
	color: #aaa;
	font-style: italic;
	font-size: 0.9em;
}

.editable-field {
	margin: 0 -4px;
	padding: 0 4px;
	background: transparent;
	border: 1px solid transparent;
	cursor: pointer;
}

.editable-field:hover, .editable-field:focus {
	border: 1px solid gray;
}

.actions {
	position: absolute;
	top: 5px;
	right: 5px;
	padding-bottom: 6px;
	line-height: 0.7;
}
</style>
